import { AppTemplate } from '../../models/app-template.class';
import { AssetData } from '../../models/assetdata.class';
import { AssetService } from '../../models/assetservice.class';
import { BridgeNode } from '../../models/bridgeNode.interface';
import { ReconciliationConfiguration } from '../../models/reconciliation-configuration.class';

import { AppConfigurator } from '../../models/app-configurator.class';

export const appsState: AppsState = {
    appsHelpDocumentsByServiceId: {},
    subscribedServices: {},
    bridgeServices: {},
    assetsMetaData: {},
    nonMappedServices: {},
    assetsMetaDataPermissions: {},
    reconConfiguration: {},
    loading: {},
    selectedApp: {
        bridgeServiceId: undefined,
        packageServiceId: undefined,
        serviceId: undefined,
        restApiName: undefined,
        category: undefined,
        entityId: undefined,
    },
    appsTemplate: {},
    appConfigurators: {},
    assetsWithLatestVersion: undefined,
    assetsForSubscriptionApprovalFilters: [],
    packagedAppsMap: {},
    taxonomyApp: undefined,
};

export interface AppsState {
    appsHelpDocumentsByServiceId: { [property: string]: { [property: string]: string }[] };
    bridgeServices: {
        [serviceId: string]: {
            [property: string]: BridgeNode;
        };
    };
    subscribedServices: {
        [property: string]: AssetService[];
    };
    nonMappedServices: {
        [property: string]: AssetService[];
    };
    appsTemplate: {
        [property: string]: {
            // organizationId vs services map
            [property: string]: {
                // serviceId vs template
                isOfCurrentOrg: boolean;
                uiTemplate: AppTemplate;
            };
        };
    };
    assetsMetaData: {
        [property: string]: {
            [property: string]: AssetData;
        };
    };
    assetsMetaDataPermissions: {
        // Service ID vs permissions
        [property: string]: {};
    };
    appConfigurators: {
        // Service ID vs Configurator
        [property: string]: {
            // asset meta uid vs Configurator
            [property: string]: AppConfigurator;
        };
    };
    reconConfiguration: {
        [property: string]: ReconciliationConfiguration;
    };
    loading: {
        [property: string]: {
            meta: boolean;
            template: boolean;
            reconConfiguration: boolean;
            bridgeNodes: boolean;
            configurator: boolean;
            version: boolean;
        };
    };
    selectedApp: {
        bridgeServiceId: string;
        packageServiceId: string;
        serviceId: string;
        restApiName: string;
        category: 'Entity' | 'Details' | 'Workflow';
        entityId: string;
    };
    assetsWithLatestVersion: {
        // serviceId vs Assetwithlatestversion
        [property: string]: {
            displayName: string;
            metadataId: string;
            metadataName: string;
            metadataType: string;
            metadataVersion: string;
            organizationId: string;
            publicationState: string;
            restApiName: string;
            serviceId: string;
            updatedOn: string;
        };
    };
    assetsForSubscriptionApprovalFilters: {
        serviceId: string;
        restApiName: string;
        displayName: string;
        organizationId: string;
    }[];
    packagedAppsMap: {
        [property: string]: AssetService[];
    };
    taxonomyApp: AssetService;
}
